import * as React from "react";
const SvgTwoBarsIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, id: "Layer_1", focusable: "false", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", style: {
  enableBackground: "new 0 0 24 24"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20,9H4v2h16V9z M4,15h16v-2H4V15z" }));
export default SvgTwoBarsIcon;
